import EventList from "view/EventList.js";

import connectFunction from "redux/connectFunction";

function mapStateToProps(state) {
  return {
    articles: state.articles,
    alert: state.alert,
    cart: state.cart,
    language: state.language,
    museum: state.museum,
    currency: state.currency,
    shippingInfo: state.shippingInfo,
    customStyle: state.customStyle,
    cartParams: state.cartParams,
    eventSelected: state.eventSelected
  };
}

const EventListContainer = connectFunction(mapStateToProps)(EventList);
export default EventListContainer;
